import type { Article } from "@/types/content";
import { formatCount, getCategoryStyle } from "@/utils/format";
import { categories } from "@/mocks/categories";

interface ArticleHeaderProps {
  article: Article;
}

export default function ArticleHeader({ article }: ArticleHeaderProps) {
  const style = getCategoryStyle(article.category);
  const catName =
    categories.find((item) => item.slug === article.category)?.name ?? "热瓜";

  return (
    <header className="w-full">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <span
          className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs ${style.chip}`}
        >
          <i className="ri-flashlight-line" aria-hidden="true"></i>
          {catName}
        </span>
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-50 border border-primary-100 text-xs text-primary-600">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
          持续更新中
        </span>
      </div>

      <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 leading-snug tracking-tight">
        {article.title}
      </h1>

      <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
        {article.summary}
      </p>

      <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs md:text-sm text-foreground-400 border-b border-background-200 pb-5">
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-user-star-line text-primary-500" aria-hidden="true"></i>
          {article.author}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-time-line" aria-hidden="true"></i>
          {article.publishTime}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-eye-line" aria-hidden="true"></i>
          {formatCount(article.views)} 围观
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-chat-3-line" aria-hidden="true"></i>
          {formatCount(article.comments)} 讨论
        </span>
        <span className="inline-flex items-center gap-1.5 text-primary-600">
          <i className="ri-fire-line" aria-hidden="true"></i>
          热度 {formatCount(article.hot)}
        </span>
      </div>
    </header>
  );
}